/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC } from 'react';

interface Props {
  button_text: string;
  button_id: string;
  button_class: string;
  hittype: string;
  event_category: string;
  event_action: string;
  event_label: string;
  event_value?: string;
  onClickMethod: any;
}
const WaEventHazteOroButton: FC<Props> = (props) => {
  const {
    button_text,
    button_id,
    button_class,
    hittype,
    event_category,
    event_action,
    event_label,
    event_value,
    onClickMethod,
  } = props;

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      href=""
      id={button_id}
      className={button_class}
      data-wa-hittype={hittype}
      data-wa-event-category={event_category}
      data-wa-event-action={event_action}
      data-wa-event-label={event_label}
      data-wa-event-value={event_value}
      onClick={onClickMethod}
    >
      {button_text}
    </a>
  );
};
export default WaEventHazteOroButton;
